import { render, staticRenderFns } from "./lifeEstimate.vue?vue&type=template&id=4b1cff10&scoped=true&"
import script from "./lifeEstimate.vue?vue&type=script&lang=js&"
export * from "./lifeEstimate.vue?vue&type=script&lang=js&"
import style0 from "./lifeEstimate.vue?vue&type=style&index=0&id=4b1cff10&prod&lang=scss&scoped=true&"
import style1 from "./lifeEstimate.vue?vue&type=style&index=1&id=4b1cff10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1cff10",
  null
  
)

export default component.exports